import NoticeRegister from "../components/pages/Notice/NoticeRegister";

export default function NoticeRegisterPage() {
  return (
    <>
      <NoticeRegister />
    </>
  );
}
